import { render, staticRenderFns } from "./AppointmentNotificationMessagedCustomer.vue?vue&type=template&id=0f4c930c"
import script from "./AppointmentNotificationMessagedCustomer.vue?vue&type=script&lang=js"
export * from "./AppointmentNotificationMessagedCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports